// Mirrors the server guard (makeCharRunCollapser). Bounds any run of the SAME
// character to maxRun. Nothing legitimate has 200+ identical consecutive chars
// (markdown |---| separators are far shorter), so real content is untouched.
//
// Stored bot messages from before the server-side cap can contain a runaway run
// (e.g. a table cell padded with 191k dashes in a 414 KB message). react-markdown
// renders that as a single unbreakable "word" and the browser freezes on layout,
// so every message is collapsed before it reaches the markdown renderer. O(n).
export function collapseRunawayCharRuns(text: string, maxRun = 200): string {
    if (!text || text.length <= maxRun) return text;
    let out = '', start = 0, lastCode = -1, run = 0;
    for (let i = 0; i < text.length; i++) {
        const code = text.charCodeAt(i);
        if (code === lastCode) {
            run++;
            if (run > maxRun) { out += text.slice(start, i); start = i + 1; }
        } else {
            lastCode = code;
            run = 1;
        }
    }
    return out + text.slice(start);
}
